module.exports = __webpack_public_path__ + "static/media/ic-adress.7f6239cd.svg";